import React, { useState } from 'react'

const CampaignName = ({ campaignId, initialName }) => {
  const [name, setName] = useState(initialName || '')
  const [draft, setDraft] = useState(name)
  const [editing, setEditing] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const save = async (event) => {
    event.preventDefault()
    if (saving || !draft.trim()) return
    setSaving(true)
    setError('')
    try {
      const response = await fetch(`/campaigns/${campaignId}/rename`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        },
        body: JSON.stringify({ name: draft.trim() }),
      })
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || 'Could not rename campaign.')
      setName(data.name)
      setEditing(false)
    } catch (failure) {
      setError(failure.message || 'Could not rename campaign.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className='min-w-0'>
      <div className='flex items-center gap-3'>
        <h1 className='text-3xl font-semibold text-slate-900 break-words min-w-0'>{name}</h1>
        <button type='button' className='text-sm text-slate-500 hover:text-blue-600'
          disabled={saving} aria-label={`Rename campaign ${name}`}
          onClick={() => { setDraft(name); setError(''); setEditing(true) }}>
          Rename
        </button>
      </div>
      {editing && (
        <form onSubmit={save} className='mt-3'>
          <div className='flex items-center gap-2'>
            <input autoFocus aria-label='Campaign name' value={draft} disabled={saving}
              className='flex-1 min-w-0 rounded border border-slate-300 px-3 py-2 text-sm'
              onChange={(event) => setDraft(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Escape' && !saving) setEditing(false)
                if (event.key === 'Enter') save(event)
              }} />
            <button type='button' onClick={save} disabled={saving || !draft.trim()}
              className='text-sm text-blue-600 disabled:opacity-50'>
              {saving ? 'Saving…' : 'Save'}
            </button>
            <button type='button' disabled={saving} className='text-sm text-slate-500'
              onClick={() => setEditing(false)}>Cancel</button>
          </div>
          {error && <p role='alert' className='mt-1 text-sm text-red-600'>{error}</p>}
        </form>
      )}
    </div>
  )
}

export default CampaignName
